import { AttributeType, type AttributeDefinitionOption } from "../../../clients/Purchaser/Attributes";
import { FloatingEmptyText, MenuCheckboxItem } from "../../DesignSystem";
import type { AttributeFilter, MultiSelectAttributeFilter, SelectAttributeFilter, SetAttributeFilter } from "../types";

type SelectFilterType = AttributeType.SELECT | AttributeType.MULTI_SELECT;

type SelectAttributeFilterSubmenuProps = {
    attributeId: number;
    type: SelectFilterType;
    options: AttributeDefinitionOption[];
    currentFilter?: SelectAttributeFilter | MultiSelectAttributeFilter;
    setAttributeFilter: SetAttributeFilter;
};

// Shared submenu for SELECT and MULTI_SELECT filters. Both filter modes are
// multi-pick on the attribute's options; the backend differs only in whether
// a matching entity has one chosen option (SELECT) or many (MULTI_SELECT).
function SelectAttributeFilterSubmenu({ attributeId, type, options, currentFilter, setAttributeFilter }: SelectAttributeFilterSubmenuProps) {
    const currentIds = currentFilter?.optionIds ?? [];
    const currentSet = new Set(currentIds);

    const toggle = (optionId: number) => {
        const updated = currentSet.has(optionId) ? currentIds.filter(id => id !== optionId) : [...currentIds, optionId];
        // Empty list clears the filter (resolveFilterUpdate handles removal via isFilterActive).
        const next: AttributeFilter = { type, attributeId, optionIds: updated };
        setAttributeFilter(next);
    };

    if (options.length === 0) {
        return (
            <FloatingEmptyText>No options defined</FloatingEmptyText>
        );
    }

    return (
        <>
            {options.map(option => (
                <MenuCheckboxItem key={option.id} checked={currentSet.has(option.id)} onChange={() => toggle(option.id)}>
                    {option.value}
                </MenuCheckboxItem>
            ))}
        </>
    );
}

export default SelectAttributeFilterSubmenu;
